module.exports = __webpack_public_path__ + "static/media/ic_video_off.80fb0520.svg";